import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';


export class OrderDependencyObject {
  private referencePath: string;
  static ORDER_ACTIVITIES_CONTEXT = "activityDependency/";
  static ORDER_SERVICES_CONTEXT = "serviceDependency/";

  constructor(private dependencyType: string, private activityName: string, private service: string,
    private status: OrderStatusObject, private lastModification: Date, private reference: string) {
    this.referencePath = this.getContext() + this.reference;
  }

  static create(): OrderDependencyObject {

    return new OrderDependencyObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, OrderStatusObject.create(),
      new Date(), StringUtils.NOT_AVALIABLE);
  }

  public getDependencyType(): string {
    return this.dependencyType;
  }

  public getActivityName(): string {
    return this.activityName;
  }

  public getService(): string {
    return this.service;
  }

  public getStatus(): OrderStatusObject {
    return this.status;
  }

  public getLastModification(): Date {
    return this.lastModification;
  }

  public getReference(): string {
    return this.reference;
  }

  public getReferencePath(): string {
    return this.referencePath;
  }

  private getContext(): string {
    let context = OrderDependencyObject.ORDER_ACTIVITIES_CONTEXT;
    if (this.dependencyType == "activity") {
      context = OrderDependencyObject.ORDER_ACTIVITIES_CONTEXT
    }
    else if (this.dependencyType == "order") {
      context = OrderDependencyObject.ORDER_SERVICES_CONTEXT;
    }
    return context;
  }

  public isFetched(): boolean {
    return this.activityName !== StringUtils.NOT_AVALIABLE;
  }



}
